<template>
  <TableComp
    :headers="headers"
    :name="$t('global.addons')"
    :status="status"
    :number-of-items="addons.length"
    empty-image="addons"
  >
    <template v-slot:desktop>
      <TableRow v-for="(addon, index) in addons" :key="index">
        <td class="align-middle">{{ addon.name }}</td>
        <td class="align-middle text-center">{{ addon.quantity }}</td>
        <td class="align-middle text-center">{{ getPrice(addon) }}</td>
      </TableRow>
    </template>
    <template v-slot:mobile>
      <TableMobileRow v-for="(addon, index) in addons" :key="index">
        <template v-slot:header>
          <div class="d-flex align-items-center">{{ addon.name }}</div>
        </template>
        <template v-slot:content>
          <div class="row">
            <div class="col">{{ $t("global.quantity") }}:</div>
            <div class="col">{{ addon.quantity }}</div>
          </div>
          <div class="row">
            <div class="col">{{ $t("global.price") }}:</div>
            <div class="col">{{ getPrice(addon) }}</div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import { moneyFormat } from "leatherman-js/utils/formatters/money";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import TableRow from "@/components/display/table/TableRow";

export default {
  name: "AddonsTable",
  props: {
    addons: {
      type: Array,
      default: () => [],
    },
    status: Object,
  },
  components: {
    TableComp,
    TableMobileRow,
    TableRow,
  },
  setup(props, { root }) {
    const headers = [
      new TableHeader(root.$t("global.addon"), undefined),
      new TableHeader(root.$t("global.quantity"), "justify-content-center"),
      new TableHeader(root.$t("global.price"), "justify-content-center"),
    ];

    const getPrice = (addon) => moneyFormat(addon.price);

    return {
      getPrice,
      headers,
    };
  },
};
</script>
